import MiniprograpSelector from './miniprogram-selector.vue'

MiniprograpSelector.install = function (Vue) {
	Vue.component(MiniprograpSelector.name, MiniprograpSelector);
}

export default MiniprograpSelector;